import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const CarouselPrevArrow = ({ className, onClick }) => {
    return (
        <button
            className={className}
            onClick={onClick}
            aria-label="Previous Arrow">
            <div className="carousel-arrow">
                <FontAwesomeIcon icon="arrow-left" />
            </div>
        </button>
    )
}

export default CarouselPrevArrow
